import Vue from 'vue'
import VueRouter from 'vue-router'
import { RouterOptions, RouteConfig } from 'vue-router';
import store from '../store'
import firebaseHelper from '@/helper/firebaseHelper'

import Login from '../components/Auth/LoginPage.vue'

import SetupPage from '../components/Setup/SetupPage.vue'
import AdminManagement from '../components/Admin/adminPage.vue'
import SchedulingPage from '../components/SmartScheduling/SchedulingPage.vue'
import SettingPage from '../components/Setting/SettingPage.vue'

import PageNotFound from '../components/TheNotFound.vue'

Vue.use(VueRouter)

let routes = <Array<RouteConfig>>[
  { // NOTE: Login
    path: '/login/:lang',
    name: 'Login',
    component: Login,
    meta: { isFullPage: true }
  },
  { // NOTE: Setup
    path: '/setup',
    name: 'Setup',
    component: SetupPage,
    meta: {
      requiresAuth: true,
      firstLogin: true,
      isFullPage: true
    }
  },
  { // NOTE: Main Contents
    path: '/',
    component: { template: '<router-view />' },
    meta: { requiresAuth: true },
    children:[
      { // NOTE: For Admin
        path: '/admin',
        name: 'AbejaAdmin',
        component: AdminManagement,
        meta: { requiredAdmin: true },
      },
      { // NOTE: SmartScheduling
        path:'/scheduling',
        name: 'SmartScheduling',
        component: SchedulingPage
      },
      { // NOTE: Settings
        path: '/setting',
        name: 'Setting',
        component: SettingPage,
        meta: { requiredOwner: true }
      },
    ]
  },
  { // NOTE: 404
    path: '*',
    name: 'NotFound',
    component: PageNotFound,
    meta: { isFullPage: true }
  }
]

const routerOps = <RouterOptions>{
  routes: routes,
  mode: 'history',
  base: process.env.BASE_URL,
}

const router = new VueRouter(routerOps)

router.beforeEach(async(to, _, next) => {

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  // const requiredAdmin = to.matched.some((record) => record.meta.requiredAdmin)
  // const requiredOwner = to.matched.some((record) => record.meta.requiredOwner)

  firebaseHelper.firebaseApp.auth().onAuthStateChanged( async (user) => {
    const isLogin = !!user
    // console.log('isLogin', isLogin)
    if (isLogin) {
      await store.dispatch('auth/setCurrentData')
      // .then(() => {
      //   if (store.state?.auth.isNewUser) {
      //     if (store.state?.auth.signInMethod === 'google.com') store.dispatch('auth/setGoogleUserAuth', 'router new access')
      //     if (store.state?.auth.signInMethod === 'microsoft.com') store.dispatch('auth/setGoogleUserAuth', 'router new access')
      //   }
      //   else {
      //     store.dispatch('auth/setApiUserAuth')
      //   }
      // })
      // await store.dispatch('auth/setCurrentData')
      // if (store.state?.auth.isNewUser) {
      //   if (store.state?.auth.signInMethod === 'google.com') store.dispatch('auth/setGoogleUserAuth', 'router new access')
      //   if (store.state?.auth.signInMethod === 'microsoft.com') store.dispatch('auth/setGoogleUserAuth', 'router new access')
      // } else {
      //   store.dispatch('auth/setApiUserAuth')
      // }
    }
    // NOTE: root pathを参照した場合
    if ( to.path === '/' ) {
      if ( isLogin ) {
        next({
          name: 'SmartScheduling'
        })
      } else {
        next({
          name: 'Login',
          params: { lang: 'ja' }
        })
      }
    }
    // TODO: 認証が必要な画面の認証判断処理
    // NOTE: 認証処理周りの情報
    if (requiresAuth) {
      if (!isLogin) {
        next({
          name: 'Login',
          params: { lang: 'ja' }
        })
      } else {
        next()
      }
    } else {
      next()
    }
  })
})

export default router
